import styled from '@emotion/styled';
import React from 'react';
import { Css, ITheme, Responsive } from '../../../ui';
import { Color } from '../../../styles/Color';
import { FONT_FAMILY_MUSEO_SANS_CONDENSED } from '../../../styles/Font';
import { useGoogleTranslate } from './hooks/useGoogleTranslate';

interface IGoogleTranslateProps {
	showDropdown: boolean;
}

export default function GoogleTranslate({
	showDropdown,
}: IGoogleTranslateProps) {
	useGoogleTranslate();

	return (
		<TranslateWidgetWrapper showDropdown={showDropdown}>
			<div id="google_translate_element" />
		</TranslateWidgetWrapper>
	);
}

const TranslateWidgetWrapper = styled.div<{ showDropdown: boolean }, ITheme>`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: ${Css.pxToRem(6)};
	margin-right: ${Css.pxToRem(-50)};

	#google_translate_element {
		position: relative;
	}

	#google_translate_element,
	.goog-te-gadget,
	.goog-te-gadget > span,
	.goog-te-combo {
		display: ${({ showDropdown }) =>
			showDropdown ? 'block' : 'none'} !important;
	}

	.goog-te-gadget {
		max-width: 85%;
		font-size: ${Css.pxToRem(6)};
		margin: 0;
	}

	.goog-te-combo {
		border: none;
		background: none;
		font-family: ${FONT_FAMILY_MUSEO_SANS_CONDENSED};
		font-weight: 700;
		font-size: ${Css.pxToRem(16)};
		color: ${Color.OnBackground};
		width: 85% !important;
		margin-left: ${Css.pxToRem(-4)} !important;
		margin-bottom: 0px !important;

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			background-color: ${Color.Neutral2};
		}
	}

	.goog-te-gadget-simple {
		border: none;
		background: none;
	}

	svg {
		path {
			fill: ${(props) => props.theme.color.secondaryLight};
		}
	}

	a {
		font-size: ${Css.pxToRem(10)} !important;
		pointer-events: none;
	}
`;
